/*
 * @Author: your name
 * @Date: 2021-01-11 14:59:50
 * @LastEditTime: 2021-01-15 14:34:14
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \xdap-h5\src\vender\third-sdk\third-function\get-camera.js
 */
import { isOnlyWechat, isOnlyWeCom, isFeishu } from '@/lib/ui/utils/platform.util.js'
import { wxOpenCameraApi } from '../wx-sdk'

export function openCameraUpload() {
  return new Promise((resolve, reject) => {
    if (isOnlyWechat()) {
      wxOpenCameraApi((result) => {
        if (result) {
          resolve(result)
        } else {
          reject(new Error())
        }
      })
    } else if (isOnlyWeCom()) {

    } else if (isFeishu()) {

    }
  })
}

export function getImageFormData(dataurl) {
  let arr = dataurl.split(',')
  let mime = arr[0].match(/:(.*?);/)[1]
  let bstr = atob(arr[1])
  let n = bstr.length
  let u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new Blob([u8arr], { type: mime })
}

export function blobToFile(theBlob, fileName) {
  theBlob.lastModifiedDate = new Date()
  theBlob.name = fileName
  return theBlob
}
export function compressImg(data) {
  let file
  if (typeof data === 'string') {
    file = blobToFile(getImageFormData(data), new Date().getTime() + '.jpeg')
  } else {
    file = data
  }
  let files
  let fileSize = parseFloat(parseInt(file['size']) / 1024 / 1024).toFixed(2)
  let read = new FileReader()
  read.readAsDataURL(file)
  return new Promise(function (resolve, reject) {
    read.onload = function (e) {
      let img = new Image()
      img.src = e.target.result
      img.onload = function () {
        // 默认按比例压缩
        let w = this.width
        let h = this.height
        // 生成canvas
        let canvas = document.createElement('canvas')
        let ctx = canvas.getContext('2d')
        let base64
        // 创建属性节点
        canvas.setAttribute('width', w)
        canvas.setAttribute('height', h)
        ctx.drawImage(this, 0, 0, w, h)
        if (fileSize < 1) {
          // 如果图片小于一兆 那么不执行压缩操作
          base64 = canvas.toDataURL(file['type'], 0.8)
        } else if (fileSize > 1 && fileSize < 2) {
          // 如果图片大于1M并且小于2M 那么压缩0.5
          base64 = canvas.toDataURL(file['type'], 0.5)
        } else {
          // 如果图片超过2m 那么压缩0.2
          base64 = canvas.toDataURL(file['type'], 0.2)
        }
        // 回调函数返回file的值（将base64编码转成file）
        files = blobToFile(getImageFormData(base64), file['name']) // 如果后台接收类型为base64的话这一步可以省略
        resolve(files)
      }
    }
  })
}
